import styled, { css } from "styled-components";

const size = {
  sm: 24,
  lg: 40,
};

const fontSize = {
  sm: {
    fontSize: 12,
    lineHeight: 16,
    radius: 8,
  },
  lg: {
    fontSize: 14,
    lineHeight: 16,
    radius: 4,
  },
};

const radius = {
  sm: 4,
  lg: 8,
};

export const combinations = [
  {
    color: "rgba(0, 0, 0, 1)",
    backgroundColor: "rgba(251, 213, 213, 1)",
  },
  {
    color: "rgba(0, 0, 0, 1)",
    backgroundColor: "rgba(200, 230, 249, 1)",
  },
  {
    color: "rgba(0, 0, 0, 1)",
    backgroundColor: "rgba(220, 237, 225, 1)",
  },
  {
    color: "rgba(0, 0, 0, 1)",
    backgroundColor: "rgba(252, 236, 203, 1)",
  },
  {
    color: "rgba(0, 0, 0, 1)",
    backgroundColor: "rgba(224, 224, 224, 1)",
  },
];

export const StyledTrigger = styled.div<{
  $size: "sm" | "lg";
  $clickable: boolean;
  $type: 1 | 2 | 3 | 4 | 5 | number;
  isCollapsed: boolean;
}>`
  ${({ $type }) => `
    background-color: ${combinations?.[$type]?.backgroundColor};
    color: ${combinations?.[$type]?.color};
  `};
  width: ${({ $size }) => size[$size]}px;
  height: ${({ $size }) => size[$size]}px;
  min-width: ${({ $size }) => size[$size]}px;
  min-height: ${({ $size }) => size[$size]}px;
  border-radius: ${({ $size }) => radius[$size]}px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: ${({ $size }) => fontSize[$size].fontSize}px;
  line-height: ${({ $size }) => fontSize[$size].lineHeight}px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  pointer-events: ${({ $clickable }) => ($clickable ? "auto" : "none")};

  ${({ isCollapsed, $clickable }) =>
    isCollapsed &&
    css`
      &:hover {
        box-shadow: ${$clickable ? "0px 2px 8px rgba(0, 0, 0, 0.2)" : "none"};
      }
    `}

  &:active {
    box-shadow: none;
  }
`;
